/**
 *  Go through `otherContractHolders` and `contractInsured` array of each policy,
 *  dynamically create data columns by pushing to schema array
 */
const createSchema = (ctx, payload) => {
	/**
	 * Each item in the schema represents a column
	 * label defines the header of each column
	 * data defines the data which will be mapped
	 */

	let fetchedTemplates = ctx.$store.state.reports.templates

	let schema = fetchedTemplates.policies

	return schema
}

export default (ctx, payload) => {
	const schema = createSchema(ctx, payload)
	const header = schema.map(item => item.label)
	const body = payload.map(data => schema.map(y => [y.data(data)]))
	const workSheetData = [header, ...body]
	const workSheetColumns = schema.map(item => {
		return { wpx: 150 }
	})
	return { workSheetData, workSheetColumns }
}
